import classNames from 'classnames';
import { autobind } from 'core-decorators';
import { range } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export class DensityTable extends Component {
    static contextTypes = {
        units: PropTypes.object,
    };

    makeDensityTableEnvironments({ min, max, step }, environmentRange) {
        const { profile, type } = this.props;

        const tableEnvironments = range(min, max > 0 ? max + 1 : 24000, step);

        return tableEnvironments
            .map((env) => {
                const density =
                    profile.densities &&
                    profile.densities.find(
                        (d) => env >= d.minEnvironment && env < d.maxEnvironment && d.type === 'recommended'
                    );

                if (!density) return;

                return {
                    environment: env,
                    harvestDensity: density ? this.context.units.toDensity(density.value * 10000, type).localeValue : 0,
                };
            })
            .filter((env) => {
                if (!env) return false;
                if (environmentRange)
                    return env.environment >= environmentRange.min && env.environment <= environmentRange.max;
            });
    }

    render() {
        const { profile, environmentRange } = this.props;

        let densityTableEnvironments = this.makeDensityTableEnvironments(
            profile.densityTableConstraints[0],
            environmentRange
        );

        let cols;
        if (densityTableEnvironments.length > 5) {
            cols = [0, 1];
            const halfTable = Math.floor(densityTableEnvironments.length / 2);
            densityTableEnvironments = [
                densityTableEnvironments.slice(0, halfTable + 1),
                densityTableEnvironments.slice(halfTable + 1, densityTableEnvironments.length),
            ];
        } else {
            cols = [0];
            densityTableEnvironments = [densityTableEnvironments];
        }

        return (
            <div className={styles.root}>
                {cols.map((col) => (
                    <div className={styles.col} key={col}>
                        <div className={classNames(styles.headerRow, { [styles.hideMobile]: col === 1 })}>
                            <div className={styles.box}>{_('Ambiente estimado (kg)')}</div>
                            <div className={styles.box}>{this.context.units.getUnit('density', 'corn')}</div>
                        </div>
                        <div>
                            {densityTableEnvironments?.[col]?.map((densityTableEnvironment, i) => {
                                return (
                                    <div key={i}>
                                        <div className={styles.bodyRow}>
                                            <div className={styles.box}>{densityTableEnvironment.environment}</div>
                                            <div className={styles.box}>{densityTableEnvironment.harvestDensity}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}
